// =============================================================================
// PORTAL FLASH MESSAGE (PortalFlashMessage.js)
// =============================================================================
// Toast notification component for the portal tab.
// Adapted from cdic-portal-react/client/src/components/FlashMessage.js
// No changes needed — this component uses inline styles so no CSS conflicts.
// =============================================================================

import React, { useEffect } from 'react';

function PortalFlashMessage({ message, type = 'info', onClose }) {
  useEffect(() => {
    if (message) {
      const timer = setTimeout(() => {
        if (onClose) onClose();
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [message, onClose]);

  if (!message) return null;

  const colors = {
    error: '#f44336',
    success: '#4caf50',
    info: '#2196f3',
  };

  return (
    <div style={{
      backgroundColor: colors[type] || colors.info,
      color: 'white',
      padding: '12px 20px',
      borderRadius: '4px',
      marginBottom: '15px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
    }}>
      <span>{message}</span>
      {onClose && (
        <button
          onClick={onClose}
          style={{
            background: 'none',
            border: 'none',
            color: 'white',
            cursor: 'pointer',
            fontSize: '18px',
            marginLeft: '10px',
            padding: '0',
            width: 'auto',
            minWidth: 'auto',
            textTransform: 'none',
          }}
        >
          &times;
        </button>
      )}
    </div>
  );
}

export default PortalFlashMessage;
